//设备统计1.设备统计 17:37更新
// 当前设备数：
// 运行设备数：
// 停机设备数：
// 故障设备数：
export const device_info = {
  a1: '195',
  a2: '156',
  a3: '39',
  a4: '0'
}
// 2.自动引导车数据
// 设备编号： name
// 电池电量： power
// 作业时间  time
// 位置  center
// 今日箱数 box
// 设备状态 state
export const automation_agv = [
  {
    center: [36.00719780068317,120.22508846674705],
    name: 'AGV301',
    power: '72%',
    time: '16.27',
    box: 0,
    rotation:0,
    state: '正常'
  },
  {
    center: [36.009894902411034,120.2298394614528],
    name: 'AGV304',
    power: '90%',
    time: '13.27',
    box: 0,
    state: '正常',
    rotation:1.58
  },
  {
    center: [36.00718656258765,120.22545820257348],
    name: 'AGV302',
    power: '68%',
    time: '16.11',
    box: 0,
    state: '正常',
    rotation:1.58
  },
  {
    center: [36.010160, 120.230406],
    name: 'AGV303',
    power: '76%',
    time: '13.15',
    box: 0,
    state: '正常',
    rotation:1.58
  },
  {
    center: [36.010473, 120.230566],
    name: 'AGV306',
    power: '36%',
    time: '9.55',
    box: 0,
    state: '正常',
    rotation:0,
  },
  {
    center: [36.0105723027344,120.23098724748274],
    name: 'AGV310',
    power: '77%',
    time: '12.15',
    box: 0,
    state: '正常',
    rotation:1.58
  },
  {
    center: [36.009433262412756,120.22911195720464],
    name: 'AGV305',
    power: '92%',
    time: '6.12',
    box: 0,
    state: '正常',
    rotation:1.58
  },
  {
    center: [36.01083872886197,120.2314132513126],
    name: 'AGV315',
    power: '92%',
    time: '6.12',
    box: 0,
    state: '正常',
    rotation:1.58
  },
  {
    center: [36.0080085910073,120.22638649484696],
    name: 'AGV345',
    power: '90%',
    time: '8.32',
    box: 0,
    state: '正常',
    rotation:0,
  },
  {
    center: [36.00794846860609,120.2267398487204],
    name: 'AGV346',
    power: '0%',
    time: '0',
    box: 0,
    state: '正常',
    rotation:1.58
  },
  {
    center: [36.007354664500866,120.22585658311998],
    name: 'AGV347',
    power: '95%',
    time: '0.95',
    box: 0,
    state: '正常',
    rotation:1.58
  },
  {
    center: [36.0078353202449,120.22610673216816],
    name: 'AGV348',
    power: '78%',
    time: '1.5',
    box: 0,
    state: '正常',
    rotation:0,
  },
  {
    center: [36.008372054503994,120.22696928199755],
    name: 'AGV349',
    power: '73%',
    time: '1.25',
    box: 0,
    state: '正常',
    rotation:0,
  },
  {
    center: [36.00828936756076, 120.22728623630418],
    name: 'AGV350',
    power: '25%',
    time: '10.95',
    box: 0,
    state: '正常',
    rotation:1.58
  },
  {
    center: [36.00855609255123, 120.22769714412148],
    name: 'AGV309',
    power: '95%',
    time: '0.95',
    rotation:1.58
  },
  {
    center: [36.00873652341227,120.22754742159522],
    name: 'AGV351',
    power: '95%',
    time: '0.95',
    box: 0,
    state: '正常',
    rotation:0,
  },
  {
    center: [36.00891515524296,120.22814817311027],
    name: 'AGV353',
    power: '95%',
    time: '10.35',
    box: 0,
    state: '正常',
    rotation:1.58
  },
  {
    center: [36.00924821056875, 120.22844228308679],
    name: 'AGV352',
    power: '75%',
    time: '7.95',
    box: 0,
    state: '正常',
    rotation:0
  }
]
// 3.轨道桥设备数据
// 总工时：
// 总工量：
export const bridge_info = {
  a1: '0.00',
  a2: '0'
}
//轨道桥列表
// 设备编号：
// 作业/运行时长：
// 今日箱数；
// 设备状态
export const bridge_list = [
  {
    name: 'AS202W',
    time: '0',
    num: '0',
    state: '正常',
    center: [36.005899, 120.226710]
  },
  {
    name: 'AS202L',
    time: '0',
    num: '0',
    state: '正常',
    center: [36.005061, 120.227981]
  },
  {
    name: 'AS203W',
    time: '0',
    num: '0',
    state: '正常',
    center: [36.006793, 120.227232]
  },
  {
    name: 'AS203L',
    time: '0',
    num: '0',
    state: '正常',
    center: [36.007248, 120.227236]
  },
  {
    name: 'AS204W',
    time: '0',
    num: '0',
    state: '正常',
    center: [36.005441, 120.228983]
  },
  {
    name: 'AS204L',
    time: '0',
    num: '0',
    state: '正常',
    center: [36.007349, 120.228124]
  },
  {
    name: 'AS205W',
    time: '0',
    num: '0',
    state: '正常',
    center: [36.006243, 120.229085]
  },
  {
    name: 'AS205L',
    time: '0',
    num: '0',
    state: '正常',
    center: [36.005967, 120.230840]
  },
  {
    name: 'AS206W',
    time: '0',
    num: '0',
    state: '正常',
    center: [36.008372, 120.228506]
  },
  {
    name: 'AS206L',
    time: '0',
    num: '0',
    state: '正常',
    center: [36.006123, 120.231056]
  },
  {
    name: 'AS207W',
    time: '0',
    num: '0',
    state: '正常',
    center: [36.008049, 120.229724]
  },
  {
    name: 'AS207L',
    time: '0',
    num: '0',
    state: '正常',
    center: [36.007749, 120.230042]
  },
  {
    name: 'AS208W',
    time: '0',
    num: '0',
    state: '正常',
    center: [36.007064, 120.232088]
  },
  {
    name: 'AS208L',
    time: '0',
    num: '0',
    state: '正常',
    center: [36.007239, 120.232846]
  },
]

// 4.桥吊设备数据
// 总工时：
// 总工量：
export const crane_info = {
  a1: '0.00',
  a2: '0'
}
//桥吊列表
// 设备编号：
// 作业/运行时长：
// 今日箱数；
// 设备状态：
export const crane_list = [
  {
    name: 'STS101',
    time: '0',
    num: '0',
    state: '正常',
    center: [36.00762749290265,120.22451214019316]
  },
  {
    name: 'STS102',
    time: '0',
    num: '0',
    state: '正常',
    center: [36.00786539314132,120.2248790850975]
  },
  {
    name: 'STS103',
    time: '0',
    num: '0',
    state: '正常',
    center: [36.00836138172354,120.22568077506536]
  },
  {
    name: 'STS104',
    time: '0',
    num: '0',
    state: '正常',
    center: [36.00963046343754,120.22772165862509]
  },
  {
    name: 'STS105',
    time: '0',
    num: '0',
    state: '正常',
    center: [36.010088595737116,120.2284465580244]
  },
  {
    name: 'STS106',
    time: '0',
    num: '0',
    state: '正常',
    center: [36.010401165568084,120.22896912760169]
  },
  {
    name: 'STS107',
    time: '0',
    num: '0',
    state: '正常',
    center: [36.01073330850345,120.22949467966619]
  },
  {
    name: 'STS108',
    time: '0',
    num: '0',
    state: '正常',
    center: [36.01149316563141,120.23080151895945]
  },
  {
    name: 'STS109',
    time: '0',
    num: '0',
    state: '正常',
    center: [36.01197610309651,120.23155154383487]
  },
  {
    name: 'STS110',
    time: '0',
    num: '0',
    state: '正常',
    center: [36.01323670266389,120.23347854178814]
  },
  {
    name: 'STS111',
    time: '0',
    num: '0',
    state: '正常',
    center: [36.0135156988013,120.2338920925427]
  },
  {
    name: 'STS112',
    time: '0',
    num: '0',
    state: '正常',
    center: [36.013712458932076,120.23428399300343]
  },
  {
    name: 'STS113',
    time: '0',
    num: '0',
    state: '正常',
    center: [36.013979138509725,120.2347125768473]
  }
]

// 干散货码头 设备信息
// 1.门机
// 设备名称：name
// 设备状态：state
// 设备位置： center
// 操作模式:  a1
//  回转角度:a2
// 起升位置:a3
// 变幅位置:a4
//  大车位置:a5
// 门机装载量:a6
// 变幅速度：a7
// 回转速度：a8
// 起升速度：a9
export const door_list = [
  {
    name: '70#门机',
    state: '空闲',
    center: [36.034670, 120.227919],
    a1: '自动',
    a2: '0.96875',
    a3: '0.609291',
    a4: '16.32581',
    a5: '206.87916',
    a6: '7.2',
    a7: '0.0%',
    a8: '0.0%',
    a9: '0.0%'
  },
  {
    name: '71#门机',
    state: '空闲',
    center: [36.035020, 120.228174],
    a1: '自动',
    a2: '0.67873',
    a3: '0.509691',
    a4: '13.33581',
    a5: '416.37915',
    a6: '0.0',
    a7: '0.0%',
    a8: '0.0%',
    a9: '0.0%'
  },
  {
    name: '72#门机',
    state: '空闲',
    center: [36.035233, 120.228326],
    a1: '自动',
    a2: '27.796875',
    a3: '-1.20757468',
    a4: '15.380064',
    a5: '263.90137',
    a6: '0.0',
    a7: '0.0%',
    a8: '0.0%',
    a9: '0.0%'
  },
  {
    name: '73#门机',
    state: '空闲',
    center: [36.035480, 120.228557],
    a1: '自动',
    a2: '0.96875',
    a3: '0.609291',
    a4: '16.32581',
    a5: '206.87916',
    a6: '0.2',
    a7: '0.0%',
    a8: '0.0%',
    a9: '0.0%'
  },
  {
    name: '74#门机',
    state: '空闲',
    center: [36.035791, 120.228781],
    a1: '自动',
    a2: '0.96875',
    a3: '0.609291',
    a4: '16.32581',
    a5: '206.87915',
    a6: '0.2'
  },
  {
    name: '75#门机',
    state: '空闲',
    center: [36.036128, 120.229100],
    a1: '自动',
    a2: '0.96875',
    a3: '0.609291',
    a4: '16.32581',
    a5: '206.87916',
    a6: '0.2',
    a7: '0.0%',
    a8: '0.0%',
    a9: '0.0%'
  },
  {
    name: '76#门机',
    state: '空闲',
    center: [36.036407, 120.229260],
    a1: '自动',
    a2: '318.3047',
    a3: '-0.389881',
    a4: '19.51252',
    a5: '8.99247',
    a6: '0.0',
    a7: '0.0%',
    a8: '0.0%',
    a9: '0.0%'
  },
  {
    name: '77#门机',
    state: '空闲',
    center: [36.033490, 120.227009],
    a1: '自动',
    a2: '356.01562',
    a3: '-0.549539',
    a4: '18.263386',
    a5: '376.18045',
    a6: '0.0',
    a7: '0.0%',
    a8: '0.0%',
    a9: '0.0%'
  },
  {
    name: '78#门机',
    state: '空闲',
    center: [36.033075, 120.226673],
    a1: '自动',
    a2: '355.57812',
    a3: '-0.4049',
    a4: '16.954626',
    a5: '436.59485',
    a6: '21.3',
    a7: '0.0%',
    a8: '0.0%',
    a9: '0.0%'
  },
  {
    name: '79#门机',
    state: '空闲',
    center: [36.032777, 120.226418],
    a1: '自动',
    a2: '2.0',
    a3: '-0.0000049',
    a4: '15.491021',
    a5: '496.87915',
    a6: '20.3',
    a7: '0.0%',
    a8: '0.0%',
    a9: '0.0%'
  },
  {
    name: '80#门机',
    state: '空闲',
    center: [36.032427, 120.226170],
    a1: '自动',
    a2: '33.851562',
    a3: '-0.999542',
    a4: '19.65695',
    a5: '552.06036',
    a6: '0.0',
    a7: '0.0%',
    a8: '0.0%',
    a9: '0.0%'
  }
]
// 2.堆取料机
// 设备名称：name
// 设备状态：state
// 瞬时流量：current
// 设备位置：center
// 操作模式:a1
// 大车速度:a2
// 回转角度:a3
// 回转速度:a4
// 俯仰角度:a5
// 俯仰速度：a6
// 大车位置：a7
export const stacker_list = [
  {
    name: '8#堆取料机',
    state: '空闲',
    current: '0.0',
    center: [36.029747, 120.217143],
    a1: '自动',
    a2: '0.0%',
    a3: '24.95°',
    a4: '-0.202401%',
    a5: '-3.55°',
    a6: '0.0%',
    a7: '364.443'
  },
  {
    name: '11#堆取料机',
    state: '空闲',
    current: '0.0',
    center: [36.028757, 120.225025],
    a1: '自动',
    a2: '0.0%',
    a3: '24.95°',
    a4: '-0.202401%',
    a5: '-3.55°',
    a6: '0.0%',
    a7: '364.443'
  },
  {
    name: '12#堆取料机',
    state: '空闲',
    current: '0.0',
    center: [36.027778, 120.222448],
    a1: '自动',
    a2: '0.0%',
    a3: '24.95°',
    a4: '-0.202401%',
    a5: '-3.55°',
    a6: '0.0%',
    a7: '364.443'
  },
  {
    name: '13#堆取料机',
    state: '空闲',
    current: '0.0',
    center: [36.028113, 120.221863],
    a1: '自动',
    a2: '0.0%',
    a3: '24.95°',
    a4: '-0.202401%',
    a5: '-3.55°',
    a6: '0.0%',
    a7: '364.443'
  },
  {
    name: '21#堆取料机',
    state: '空闲',
    current: '0.0',
    center: [36.027789, 120.218231],
    a1: '自动',
    a2: '0.0%',
    a3: '-7.08°',
    a4: '0.0%',
    a5: '-0.21°',
    a6: '0.0%',
    a7: '435.258'
  },
  {
    name: '22#堆取料机',
    state: '空闲',
    current: '0.0',
    center: [36.030802, 120.221719],
    a1: '自动',
    a2: '0.0%',
    a3: '24.95°',
    a4: '-0.202401%',
    a5: '-3.55°',
    a6: '0.0%',
    a7: '364.443'
  },
  {
    name: '23#堆取料机',
    state: '运行',
    current: '1434.56',
    center: [36.027922, 120.216253],
    a1: '自动',
    a2: '0.0%',
    a3: '17.64°',
    a4: '0.0%',
    a5: '-9.48°',
    a6: '0.0%',
    a7: '495.451'
  },
  {
    name: '31#堆取料机',
    state: '运行',
    current: '2284.83',
    center: [36.032907, 120.224843],
    a1: '自动',
    a2: '0.0%',
    a3: '-51.4°',
    a4: '39.14%',
    a5: '1.11°',
    a6: '0.0%',
    a7: '204.85991'
  },
  {
    name: '32#堆取料机',
    state: '空闲',
    current: '4.4',
    center: [36.033574, 120.223757],
    a1: '自动',
    a2: '0.0%',
    a3: '-0.8°',
    a4: '0.0%',
    a5: '0.46°',
    a6: '0.0%',
    a7: '409.95443'
  },
  {
    name: '33#堆取料机',
    state: '运行',
    current: '0.0',
    center: [36.036711, 120.224600],
    a1: '自动',
    a2: '0.0%',
    a3: '-60.55°',
    a4: '42.34%',
    a5: '-9.82°',
    a6: '0.0%',
    a7: '177.471'
  },
]
// 3.装载机
// 流机类型：type
// 车牌：plate
// 位置：center
// 资料更新时间：time
// 司机: driver
// 运行状态：state
// 方向（北向夹角）：direct
// 速度：v
export const load_list = [
  {
    type: '装载车',
    plate: '162',
    center: [36.029367, 120.211570],
    driver: '',
    state: '0',
    direct: '163',
    v: '10'
  },
  {
    type: '装载车',
    plate: '223',
    center: [36.028238, 120.214236],
    driver: '李凯',
    state: '0',
    direct: '0',
    v: '0'
  },
  {
    type: '装载车',
    plate: '211',
    center: [36.029118, 120.216018],
    driver: '0',
    state: '0',
    direct: '0',
    v: '0'
  },
  {
    type: '装载车',
    plate: '168',
    center: [36.031642, 120.218468],
    driver: '张世根',
    state: '0',
    direct: '209',
    v: ''
  },
  {
    type: '铲车',
    plate: '8号铲车（芳华）',
    center: [36.029758, 120.219072],
    driver: '',
    state: '0',
    direct: '0',
    v: '0'
  },
  {
    type: '铲车',
    plate: '18号铲车（芳华）',
    center: [36.027511, 120.215730],
    driver: '薛卫彬',
    state: '0',
    direct: '315',
    v: '0'
  },
  {
    type: '铲车',
    plate: '22号铲车（芳华）',
    center: [36.026513, 120.217157],
    driver: '',
    state: '0',
    direct: '0',
    v: '0'
  },
  {
    type: '铲车',
    plate: '2号铲车（芳华）',
    center: [36.028925, 120.220933],
    driver: '',
    state: '0',
    direct: '269',
    v: '0'
  },
  {
    type: '铲车',
    plate: '7号铲车（芳华）',
    center: [36.028884, 120.224004],
    driver: '李凯',
    state: '0',
    direct: '194',
    v: '0'
  },
  {
    type: '铲车',
    plate: '12号铲车（芳华）',
    center: [36.028431, 120.208873],
    driver: '',
    state: '0',
    direct: '0',
    v: '0'
  },
  {
    type: '铲车',
    plate: '5号铲车（芳华）',
    center: [36.027358, 120.207753],
    driver: '王磊',
    state: '0',
    direct: '75',
    v: '0'
  },
  {
    type: '铲车',
    plate: '9号铲车（芳华）',
    center: [36.034696, 120.223704],
    driver: '',
    state: '0',
    direct: '134',
    v: '0'
  },
  {
    type: '铲车',
    plate: '3号铲车（芳华）',
    center: [36.036393, 120.225025],
    driver: '',
    state: '0',
    direct: '15',
    v: '0'
  },
  {
    type: '铲车',
    plate: '4号铲车（芳华）',
    center: [36.036337, 120.224353],
    driver: '王守富',
    state: '0',
    direct: '90',
    v: '0'
  },
  {
    type: '铲车',
    plate: '17号铲车（芳华）',
    center: [36.037054, 120.225606],
    driver: '0',
    state: '0',
    direct: '163',
    v: '0'
  },
  {
    type: '铲车',
    plate: '10号铲车（芳华）',
    center: [36.036153, 120.226427],
    driver: '0',
    state: '0',
    direct: '353',
    v: '0'
  },
  {
    type: '铲车',
    plate: '10号铲车（芳华）',
    center: [36.032727, 120.224703],
    driver: '0',
    state: '0',
    direct: '163',
    v: '0'
  },
  {
    type: '铲车',
    plate: '6号铲车（芳华）',
    center: [36.033307, 120.223494],
    driver: '0',
    state: '0',
    direct: '123',
    v: '0'
  },
  {
    type: '铲车',
    plate: '17号铲车（芳华）',
    center: [36.032096, 120.225027],
    driver: '张世根',
    state: '0',
    direct: '163',
    v: '0'
  },
]
// 4.装车机
// 设备名称：name
// 运行状态：state
// 位置：center
// 变幅速度：a1
// 操作模式: a2
//  回转角度: a3
// 起升位置:a4
// 回转速度：a5
// 起升速度:a6
//  大车位置:a7
// 变幅位置：a8

export const car_list = [
  { 
    name: '1#装车机', 
    state: '', 
    center: [36.029481, 120.222955], 
    a1: '0.0%', 
    a2: '', 
    a3: '0.0', 
    a4: '0.0', 
    a5: '0.0%', 
    a6: '0.0%', 
    a7: '0.0', 
    a8: '0.0'
  },
  { 
    name: '2#装车机', 
    state: '', 
    center: [36.025778, 120.217188], 
    a1: '0.0%', 
    a2: '', 
    a3: '0.0', 
    a4: '0.0', 
    a5: '0.0%', 
    a6: '0.0%', 
    a7: '0.0', 
    a8: '0.0'
  },
  { 
    name: '3#装车机', 
    state: '', 
    center: [36.027717, 120.219565], 
    a1: '0.0%', 
    a2: '', 
    a3: '0.0', 
    a4: '0.0', 
    a5: '0.0%', 
    a6: '0.0%', 
    a7: '0.0', 
    a8: '0.0'
  },
  { 
    name: '4#装车机', 
    state: '', 
    center: [36.030155, 120.223125], 
    a1: '0.0%', 
    a2: '', 
    a3: '0.0', 
    a4: '0.0', 
    a5: '0.0%', 
    a6: '0.0%', 
    a7: '0.0', 
    a8: '0.0'
  },
]



//之前的配置文件
export const dry_device = [
  { name: '70#', type: '堆取料机', mapType: 'menji-device', icon: 'device3', center: [36.0276538006434, 120.21340300338792], mode: 'mark', w: 20, h: 100, rotation: 1 },
  { name: '71#', type: '堆取料机', mapType: 'menji-device', icon: 'device3', center: [36.030537210766084, 120.21661540319134], mode: 'mark', w: 20, h: 100, rotation: 1.5 },
  { name: '72#', type: '堆取料机', mapType: 'menji-device', icon: 'device3', center: [36.02698887067763, 120.2161432485896], mode: 'mark', w: 20, h: 100, rotation: 2 },
  { name: '73#', type: '堆取料机', mapType: 'menji-device', icon: 'device3', center: [36.028450435538566, 120.21935354386007], mode: 'mark', w: 20, h: 100, rotation: 2.6 },
  { name: '74#', type: '堆取料机', mapType: 'menji-device', icon: 'device3', center: [36.02812436828442, 120.22249918276032], mode: 'mark', w: 20, h: 100, rotation: 3 },
  { name: '75#', type: '堆取料机', mapType: 'menji-device', icon: 'device3', center: [36.02596005249633, 120.21936590941479], mode: 'mark', w: 20, h: 100, rotation: 3.5 },
  { name: '76#', type: '堆取料机', mapType: 'menji-device', icon: 'device3', center: [36.03175768449389, 120.2235520822614], mode: 'mark', w: 20, h: 100, rotation: 4 },
  { name: '77#', type: '堆取料机', mapType: 'menji-device', icon: 'device3', center: [36.036390580063326, 120.2287860216082], mode: 'mark', w: 20, h: 100, rotation: 4.5 },
  { name: '78#', type: '堆取料机', mapType: 'menji-device', icon: 'device3', center: [36.033703937962585, 120.220842861083], mode: 'mark', w: 20, h: 100, rotation: 5 },
  { name: '79#', type: '堆取料机', mapType: 'menji-device', icon: 'device3', center: [36.02917992531082, 120.21340915249836], mode: 'mark', w: 20, h: 100, rotation: 0.5 },
  { id: 'device1', name: '80#', type: '门机', mapType: 'menji-device', icon: 'device', center: [36.032070356831866, 120.22646483624428], mode: 'mark', w: 20, h: 70, rotation: -0.4 },
  { id: 'device1', name: '81#', type: '门机', mapType: 'menji-device', icon: 'device', center: [36.03346723979547, 120.22777787538863], mode: 'mark', w: 20, h: 70, rotation: -0.4 },
  { id: 'device1', name: '82#', type: '门机', mapType: 'menji-device', icon: 'device', center: [36.03464591259751, 120.22871557934731], mode: 'mark', w: 20, h: 70, rotation: -0.4 },
]